
import { Badge } from "@/components/ui/badge";
import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useTranslation } from "react-i18next";

import { AuthUserLite, SubscriptionStatusLite } from "@/types/domain";

interface MobileMenuHeaderProps {
  user: AuthUserLite | null;
  formattedTierName: string;
  badgeVariant: 'default' | 'secondary' | 'outline' | 'destructive' | null | undefined;
  hasPendingVerification: boolean;
}

const MobileMenuHeader = ({ user, formattedTierName, badgeVariant, hasPendingVerification }: MobileMenuHeaderProps) => {
  const { t } = useTranslation('common');
  
  return (
    <SheetHeader className="mb-6">
      <SheetTitle>Menu</SheetTitle>
      {user && (
        <div className="flex flex-col items-center mt-2">
          <p className="text-sm font-medium">{(user?.user_metadata as { full_name?: string; first_name?: string })?.full_name || user?.user_metadata?.first_name || "User"}</p>
          <p className="text-xs text-muted-foreground">{user?.email}</p>
          <div className="mt-1 flex gap-2 items-center">
            <Badge variant={badgeVariant}>
              {formattedTierName}
            </Badge>
            {hasPendingVerification && (
              <Badge variant="outline" className="border-amber bg-amber-soft text-brand-ink">
                {t("userMenu.paymentPending")}
              </Badge>
            )}
          </div>
        </div>
      )}
    </SheetHeader>
  );
};

export default MobileMenuHeader;
